module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isClientUser) ? _c('div', [_c('h3', [_vm._v("Cultural Resources")]), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    ref: "culturalResourceGrid",
    attrs: {
      "data": _vm.culturalResourceList,
      "columns": _vm.crGridSpec.columns,
      "options": _vm.crGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.workflowInstanceId) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId,
              hash: '#eligibility'
            },
            "tag": "a"
          }
        }) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.crAssignAvailable) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.openCrUserAssign()
      }
    }
  }, [_vm._v("Cultural Resources User Assignment")]), _vm._v(" "), _c('modal', {
    ref: "crUserAssignModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Cultural Resources User Assignment")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.closeCrUserAssign()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h4', [_vm._v("Filter By Time Period")]), _vm._v(" "), _c('div', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "timePeriodFilter"
    },
    on: {
      "change": function($event) {
        _vm.filterCrAssignmentList($event)
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("All Time Periods")]), _vm._v(" "), _vm._l((_vm.crTimePeriodList), function(period) {
    return _c('option', {
      key: period.timePeriodId,
      domProps: {
        "value": period.timePeriodId
      }
    }, [_vm._v("\r\n                                    " + _vm._s(period.timePeriodDescription) + "\r\n                                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [(_vm.crModalSelectToggle) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.selectAllCrAssignment(true)
      }
    }
  }, [_vm._v("Select All")]) : _vm._e(), _vm._v(" "), (!_vm.crModalSelectToggle) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.selectAllCrAssignment(false)
      }
    }
  }, [_vm._v("Un-Select All")]) : _vm._e(), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.crAssignmentList,
      "columns": _vm.assignGridSpec.columns,
      "options": _vm.assignGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.selectedAssignmentList),
            expression: "selectedAssignmentList"
          }],
          staticClass: "form-check-input",
          staticStyle: {
            "width": "18px",
            "height": "18px"
          },
          attrs: {
            "type": "checkbox",
            "id": props.row.culturalResourceRecordingId
          },
          domProps: {
            "value": props.row.culturalResourceRecordingId,
            "checked": Array.isArray(_vm.selectedAssignmentList) ? _vm._i(_vm.selectedAssignmentList, props.row.culturalResourceRecordingId) > -1 : (_vm.selectedAssignmentList)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.selectedAssignmentList,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = props.row.culturalResourceRecordingId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.selectedAssignmentList = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.selectedAssignmentList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selectedAssignmentList = $$c
              }
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_c('h4', [_vm._v("Assign User and Submit Workflow")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "workflowSubmit"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Workflow Action")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crWorkflowStatusId),
      expression: "crWorkflowStatusId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "workflowStatusId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.crWorkflowStatusId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select action")]), _vm._v(" "), _vm._l((_vm.crWorkflowStatusDtoNextList), function(item) {
    return _c('option', {
      key: item.workflowStatusId,
      domProps: {
        "value": item.workflowStatusId
      }
    }, [_vm._v("\r\n                                                " + _vm._s(item.submitDescription) + "\r\n                                            ")])
  })], 2)])]), _vm._v(" "), (_vm.assignableUserList.length > 0) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('workflowSubmit.assignedUserId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Assign User")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crAssignedUserId),
      expression: "crAssignedUserId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "crAssignedUserId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.crAssignedUserId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select user to assign")]), _vm._v(" "), _vm._l((_vm.assignableUserList), function(item) {
    return _c('option', {
      key: item.userId,
      domProps: {
        "value": item.userId
      }
    }, [_vm._v("\r\n                                                " + _vm._s(item.name) + "\r\n                                            ")])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('workflowSubmit.crAssignedUserId')),
      expression: "errors.has('workflowSubmit.crAssignedUserId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Assign User is required")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crNotes),
      expression: "crNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "crNotes",
      "placeholder": "Notes"
    },
    domProps: {
      "value": (_vm.crNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.crNotes = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('validationResultDisplay', {
    attrs: {
      "validationResult": _vm.crValidationResult
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.crWorkflowSubmit
    }
  }, [_vm._v("Submit")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.closeCrUserAssign()
      }
    }
  }, [_vm._v("Close")])])])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.enableNotLocatedSites) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticStyle: {
      "float": "clear",
      "margin-top": "20px"
    }
  }, [_c('h4', [_vm._v("Not Located Sites")]), _vm._v(" "), _c('v-client-table', {
    ref: "crrNotLocatedGrid",
    attrs: {
      "data": _vm.crrNotLocatedList,
      "columns": _vm.crrNotLocatedGridSpec.columns,
      "options": _vm.crrNotLocatedGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "siteNarrative",
      fn: function(props) {
        return [_c('div', {
          class: {
            'form-inline': _vm.isConsultantOnly || _vm.isAdmin
          }
        }, [_c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.siteNarrative),
            expression: "props.row.siteNarrative"
          }],
          staticClass: "form-control",
          staticStyle: {
            "min-width": "75%"
          },
          attrs: {
            "disabled": !_vm.isConsultantOnly && !_vm.isAdmin,
            "type": "textarea",
            "rows": "1"
          },
          domProps: {
            "value": (props.row.siteNarrative)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(props.row, "siteNarrative", $event.target.value)
            }
          }
        }), _vm._v(" "), ((_vm.isConsultantOnly || _vm.isAdmin) && _vm.enableNotLocatedSites) ? _c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "disabled": _vm.isNotLocatedCrrSaving,
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.saveNotLocatedCrr(props.row)
            }
          }
        }, [_vm._v("Save")]) : _vm._e()])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "spacer"
  }, [_vm._v("Isolate Resources")]), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    ref: "isolateGrid",
    attrs: {
      "data": _vm.isolateList,
      "columns": _vm.isolateGridSpec.columns,
      "options": _vm.isolateGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.workflowInstanceId) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Isolate/' + props.row.isolateId
            },
            "tag": "a"
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Submission")]), _vm._v(" "), _c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": 3000,
      "parentId": _vm.investigation.investigationId,
      "investigation": _vm.investigation
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-509623f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteSummary.vue
// module id = 936
// module chunks = 1